const de = {
  "lang.de": "DE",
  "lang.th": "ไทย",
  "lang.switch": "Sprache",

  "common.loading": "Laden…",
  "common.logout": "Abmelden",
  "common.yes": "Ja",
  "common.no": "Nein",
  "common.all": "Alle",
  "common.search": "Suchen",
  "common.reset": "Zurücksetzen",
  "common.back": "← Zurück",
  "common.next": "Weiter →",
  "common.close": "Schließen",
  "common.cancel": "Abbrechen",
  "common.save": "Speichern",
  "common.saving": "Speichert…",
  "common.free": "Kostenfrei",
  "common.minutes": "Min.",
  "common.noEntries": "Keine Einträge.",
  "common.toWebsite": "Zur Website",
  "common.toWebsiteAria": "Zur Website",

  "brand.team": "Dr. Hoffmann · Admin",

  "tabs.manual": "Manuelle Buchung",
  "tabs.revenue": "Manueller Umsatz",
  "tabs.mitarbeiterUmsatz": "Mitarbeiter Umsatz",
  "tabs.comparison": "Umsatzvergleich",
  "tabs.overview": "Übersicht",
  "tabs.calendar": "Kalender",
  "tabs.bookings": "Buchungen",
  "tabs.availability": "Verfügbarkeit",
  "tabs.customers": "Kunden",
  "tabs.topups": "Aufladungen",
  "tabs.dealmap": "CRM-Karte",
  "tabs.rechnungen": "Rechnungen",
  "tabs.navAria": "Dashboard-Bereiche",

  "umsatz.lead":
    "Umsatz aus Go-Nachrichten mit Betrag, zum Beispiel 60€. Der Anteil wird mit der Provision zum Zeitpunkt der Nachricht berechnet. Eine spätere Änderung gilt nur für neue Einträge.",
  "umsatz.employeeLead":
    "Dein Anteil aus Go-Nachrichten mit Betrag. Jeder Eintrag behält die Provision, die beim Speichern galt.",
  "umsatz.loadError": "Umsatz konnte nicht geladen werden.",
  "umsatz.empty": "Noch keine Umsätze.",
  "umsatz.totalShare": "Anteil gesamt",
  "umsatz.totalGross": "Umsatz gesamt",
  "umsatz.entryCount": "Einträge",
  "umsatz.colEmployee": "Mitarbeiter",
  "umsatz.colCompany": "Firma",
  "umsatz.colDate": "Datum",
  "umsatz.colGross": "Umsatz",
  "umsatz.colRate": "Provision",
  "umsatz.colShare": "Anteil",
  "umsatz.colActions": "Aktionen",
  "umsatz.deleteEntry": "Löschen",
  "umsatz.deleteTitle": "Umsatzeintrag löschen?",
  "umsatz.deleteConfirm": "Möchtest du den Umsatzeintrag für {{company}} ({{amount}}) wirklich dauerhaft löschen? Er verschwindet aus dem Admin Dashboard und von der Mitarbeiterseite.",
  "umsatz.deletePermanently": "Dauerhaft löschen",
  "umsatz.deleting": "Löscht…",
  "umsatz.deleteSuccess": "Umsatzeintrag dauerhaft gelöscht.",
  "umsatz.deleteError": "Umsatzeintrag konnte nicht gelöscht werden.",
  "umsatz.commission": "Provision",
  "umsatz.commissionSave": "Speichern",
  "umsatz.commissionSaving": "Speichert…",
  "umsatz.commissionSaved": "Provision gespeichert. Gilt für künftige Einträge.",
  "umsatz.commissionError": "Provision konnte nicht gespeichert werden.",
  "umsatz.commissionHint": "0–100 %. Bestehende Einträge behalten ihren Satz.",
  "umsatz.unassigned": "Nicht zugeordnet",
  "umsatz.unassignedLead":
    "Diese Go-Nachrichten konnten keinem Konto zugeordnet werden. Der WhatsApp-Absender muss zur E-Mail oder Telefonnummer eines Mitarbeiters passen.",
  "umsatz.noEntriesForEmployee": "Noch keine Einträge.",
  "umsatz.yourShare": "Dein Anteil",
  "umsatz.yourRate": "Aktuelle Provision",
  "umsatz.yourRateHint":
    "Die aktuelle Provision gilt für neue Go-Nachrichten. Ältere Einträge bleiben bei ihrem damaligen Satz.",
  "umsatz.listTitle": "Einzelne Umsätze",
  "umsatz.sectionUmsatz": "Umsatz",
  "umsatz.sectionMitarbeiter": "Mitarbeiter",
  "umsatz.createLead":
    "Lege ein Konto für den Mitarbeiter-Bereich an. Die Anmeldung erfolgt mit dieser E-Mail und diesem Passwort. Go-Nachrichten werden über die E-Mail oder Telefonnummer zugeordnet.",
  "umsatz.createFirstName": "Vorname",
  "umsatz.createLastName": "Nachname",
  "umsatz.createEmail": "E-Mail",
  "umsatz.createPhone": "Telefon",
  "umsatz.createPhoneHint": "Optional. WhatsApp-Nummer, damit Umsätze zugeordnet werden.",
  "umsatz.createPassword": "Passwort",
  "umsatz.createPasswordHint": "Mindestens 8 Zeichen.",
  "umsatz.createSubmit": "Mitarbeiter anlegen",
  "umsatz.createSubmitting": "Legt an…",
  "umsatz.createSuccess": "Mitarbeiter angelegt. Die Anmeldung ist sofort möglich.",
  "umsatz.createError": "Mitarbeiter konnte nicht angelegt werden.",
  "umsatz.edit": "Bearbeiten",
  "umsatz.editLead": "Mitarbeiterdaten ändern. Eine neue Provision gilt nur für künftige Umsätze.",
  "umsatz.editSubmit": "Änderungen speichern",
  "umsatz.editSubmitting": "Speichert…",
  "umsatz.editSuccess": "Mitarbeiter gespeichert.",
  "umsatz.editError": "Mitarbeiter konnte nicht gespeichert werden.",
  "umsatz.editCancel": "Abbrechen",
  "umsatz.editPasswordHint": "Leer lassen, um das aktuelle Passwort zu behalten.",
  "umsatz.directoryTitle": "Bestehende Mitarbeiter",
  "umsatz.directoryEmpty": "Noch keine Mitarbeiter.",
  "umsatz.entrySave": "Speichern",
  "umsatz.entrySaving": "Speichert…",
  "umsatz.entryError": "Eintrag konnte nicht gespeichert werden.",
  "umsatz.unsaved": "Du hast ungespeicherte Änderungen.",
  "umsatz.unsavedConfirm": "Bestätigen",
  "umsatz.unsavedDecline": "Verwerfen",
  "umsatz.unsavedSaving": "Speichert…",
  "umsatz.unsavedError": "Änderungen konnten nicht gespeichert werden.",
  "umsatz.entryHint": "Gilt nur für diesen Eintrag.",

  "rechnungen.title": "Rechnungen",
  "rechnungen.lead":
    "Rechnungen für geschäftliche Massagen. Sie werden mit der Buchungsbestätigung per E-Mail verschickt und liegen hier zum Ansehen und Drucken.",
  "rechnungen.searchPlaceholder": "Nummer, Kunde oder Leistung",
  "rechnungen.empty": "Noch keine Rechnungen.",
  "rechnungen.loadError": "Rechnungen konnten nicht geladen werden.",
  "rechnungen.openError": "Die Rechnung konnte nicht geöffnet werden.",
  "rechnungen.popupBlocked": "Bitte erlaube Pop-ups, um die Rechnung zu öffnen.",
  "rechnungen.colNumber": "Nummer",
  "rechnungen.colDate": "Datum",
  "rechnungen.colCustomer": "Kunde",
  "rechnungen.colService": "Leistung",
  "rechnungen.colAmount": "Betrag",
  "rechnungen.colPayment": "Zahlung",
  "rechnungen.colActions": "Aktionen",
  "rechnungen.view": "Ansehen",
  "rechnungen.print": "Drucken",

  "dealMap.title": "HubSpot Deals auf der Karte",
  "dealMap.lead":
    "Unternehmen aus der Dr.-Hoffmann-Pipeline.",
  "dealMap.lastSynced": "Zuletzt synchronisiert: {{time}}",
  "dealMap.loadingCompanies": "Unternehmen werden geladen…",
  "dealMap.stageFilter": "Deal-Phase",
  "dealMap.filters": "Filter",
  "dealMap.filtersTitle": "Filter und Sortierung",
  "dealMap.filtersActive": "{{count}} Einstellungen aktiv",
  "dealMap.stageHelp": "Status erklärt",
  "dealMap.stageHelpTitle": "Bedeutung der Status",
  "dealMap.stageHelpIntro": "Hier findest du die Bedeutung der einzelnen Kundenstatus.",
  "dealMap.stageDescription.kupfer":
    "Kunden, die zugesagt haben, sich selbstständig wieder zu melden, und bei denen der Fachberater zu über 90 % überzeugt ist, dass sie dies auch tun werden.",
  "dealMap.stageDescription.messing":
    "Kunden, die aktuell kein Interesse oder keine Möglichkeit haben, eine Massage zu buchen, aber grundsätzlich als potenzielle Kunden interessant bleiben.",
  "dealMap.stageDescription.bronze":
    "Kunden, die bereits persönlich besucht wurden, denen das Massageangebot vorgestellt wurde und bei denen der Fachberater einen positiven Eindruck gewonnen hat.",
  "dealMap.stageDescription.silber":
    "Registrierte Kunden, die bereits mindestens eine Massage bezahlt haben und mit dem Angebot zufrieden waren.",
  "dealMap.stageDescription.gold":
    "Kunden, die bereits mindestens drei Massagen bezahlt oder mindestens eine Wake-up+ bzw. Intense+ Massage gebucht und bezahlt haben.",
  "dealMap.streetFilter": "Straße",
  "dealMap.streetFilterMissing": "Ohne Straße",
  "dealMap.streetFilterHas": "Mit Straße",
  "dealMap.phoneFilter": "Telefonnummer",
  "dealMap.phoneFilterHas": "Mit Telefonnummer",
  "dealMap.phoneFilterMissing": "Ohne Telefonnummer",
  "dealMap.filterEmpty": "Keine Unternehmen für diese Filterung.",
  "dealMap.sortLabel": "Sortierung",
  "dealMap.sortNameAsc": "Name A-Z",
  "dealMap.sortLastContactDesc": "Letzte Aktivität: neueste zuerst",
  "dealMap.sortLastContactAsc": "Letzte Aktivität: älteste zuerst",
  "dealMap.refresh": "Aktualisieren",
  "dealMap.fullscreenEnter": "CRM-Karte im Vollbild anzeigen",
  "dealMap.fullscreenExit": "Vollbildmodus beenden",
  "dealMap.rotateHint": "Gerät drehen, für optimale Vollbild-Erfahrung",
  "dealMap.statTotal": "{{count}} Unternehmen",
  "dealMap.statMapped": "{{count}} auf der Karte",
  "dealMap.statMissing": "{{count}} ohne Straße/Koordinaten",
  "dealMap.loadError": "CRM-Kartendaten konnten nicht geladen werden.",
  "dealMap.stageUpdateError": "Status konnte nicht aktualisiert werden.",
  "dealMap.stageSaved": "Status gespeichert.",
  "dealMap.notesLabel": "Interne Notiz",
  "dealMap.notesPlaceholder": "Notiz zur Firma…",
  "dealMap.notesAdd": "Notiz hinzufügen",
  "dealMap.notesSaved": "Gespeichert.",
  "dealMap.notesError": "Notiz konnte nicht gespeichert werden.",
  "dealMap.notesDeleteError": "Notiz konnte nicht gelöscht werden.",
  "dealMap.notesDeleteConfirm": "Soll diese Notiz wirklich gelöscht werden?",
  "dealMap.notesDeleted": "Notiz gelöscht.",
  "dealMap.notesEmpty": "Noch keine internen Notizen.",
  "dealMap.notesCreatedAt": "Erstellt: {{date}}",
  "dealMap.notesUpdatedAt": "Bearbeitet: {{date}}",
  "dealMap.notesEdit": "Bearbeiten",
  "dealMap.notesDelete": "Löschen",
  "dealMap.notesDeleting": "Löscht…",
  "dealMap.notesCount": "{{count}} Notiz(en)",
  "dealMap.notesPreviewMeta": "{{count}} Notiz(en) · zuletzt {{date}}",
  "dealMap.notesShowAll": "Alle Notizen",
  "dealMap.companyDelete": "Firma komplett löschen",
  "dealMap.companyDeleteConfirm":
    "Soll diese Firma wirklich komplett aus der CRM-Karte gelöscht werden? Dieser Vorgang kann nicht rückgängig gemacht werden.",
  "dealMap.companyDeleting": "Firma wird gelöscht…",
  "dealMap.companyDeleteError": "Firma konnte nicht gelöscht werden.",
  "dealMap.detailsEdit": "Firmendaten ändern",
  "dealMap.detailsKicker": "Firmendaten",
  "dealMap.detailsSaved": "Firmendaten gespeichert und in HubSpot aktualisiert.",
  "dealMap.detailsSavedLocalOnly": "Firmendaten gespeichert. HubSpot konnte nicht aktualisiert werden.",
  "dealMap.detailsError": "Firmendaten konnten nicht gespeichert werden.",
  "dealMap.companyName": "Firma",
  "dealMap.contactName": "Kontakt",
  "dealMap.email": "E-Mail",
  "dealMap.domain": "Domain",
  "dealMap.address": "Adresse",
  "dealMap.street": "Straße",
  "dealMap.postalCode": "PLZ",
  "dealMap.city": "Ort",
  "dealMap.noPins": "Keine Unternehmen mit Straße und Koordinaten für diese Filterung.",
  "dealMap.listTitle": "Unternehmen",
  "dealMap.listEmpty": "Noch keine Deals synchronisiert.",
  "dealMap.searchLabel": "Unternehmen suchen",
  "dealMap.searchPlaceholder": "Firma, Adresse, Telefon, Status oder Zuständige…",
  "dealMap.searchEmpty": "Keine Unternehmen für diese Suche.",
  "dealMap.unnamed": "Ohne Firmenname",
  "dealMap.noAddress": "Keine Adresse",
  "dealMap.phone": "Telefon",
  "dealMap.noPhone": "Keine Telefonnummer",
  "dealMap.lastContactedAt": "Letzte Aktivität am",
  "dealMap.noLastContact": "keine letzte Aktivität hinterlegt",
  "dealMap.website": "Website",
  "dealMap.noWebsite": "keine Website hinterlegt",
  "dealMap.dealOwner": "Zuständig",
  "dealMap.dealOwnersWithCount": "{{names}} · {{count}} Deals",
  "dealMap.noDealOwner": "kein Zuständiger hinterlegt",
  "dealMap.stage": "Status",
  "dealMap.lostStageLegend": "Verloren",
  "dealMap.hqName": "Dr. Hoffmann Massage",
  "dealMap.hqLabel": "Unser Standort",
  "dealMap.unknownStage": "Unbekannte Phase",
  "dealMap.notGeocoded": "Nicht geocodiert",
  "dealMap.noStreet": "Keine Straße hinterlegt",
  "dealMap.vagueLocation": "Nur Land/Ort geocodiert",
  "dealMap.outsideHamburg": "Außerhalb von Hamburg",
  "dealMap.legendAria": "Farblegende der Deal-Phasen",
  "dealMap.userLocation": "Mein Standort",
  "dealMap.locationPending": "Standort wird ermittelt…",
  "dealMap.locationReady": "Standort aktiv",
  "dealMap.locationDenied": "Standortzugriff verweigert oder nicht verfügbar.",
  "dealMap.locationRetry": "Standort erneut anfragen",
  "dealMap.zoomToMe": "Zu meinem Standort",
  "dealMap.routeGenerate": "Route von meinem Standort",
  "dealMap.routeGenerateFromHq": "Route von Cremon 11",
  "dealMap.routeGenerateTwoFromUser": "2 Routen von meinem Standort",
  "dealMap.routeGenerateTwoFromHq": "2 Routen von Cremon 11",
  "dealMap.routeNeedLocation": "Bitte zuerst den Standort freigeben.",
  "dealMap.routeResolving": "Fahrradroute wird berechnet…",
  "dealMap.routeUnavailable": "Die Fahrradroute konnte nicht berechnet werden. Bitte erneut versuchen.",
  "dealMap.routeNoPins":
    "Keine passenden Unternehmen für die Route (Bronze/Silber/Gold, mit Straße, letzte Aktivität vor mehr als 2 Wochen).",
  "dealMap.routeNeedTwoPlaces":
    "Für zwei Routen werden mindestens zwei unterschiedliche Orte benötigt.",
  "dealMap.routeReady": "Fahrradroute mit {{count}} Orten und Rückkehr zum Standort auf der Karte angezeigt.",
  "dealMap.routeReadyFromHq": "Fahrradroute mit {{count}} Orten und Rückkehr zu Cremon 11 auf der Karte angezeigt.",
  "dealMap.routeReadyTwo": "Zwei Fahrradrouten mit {{a}} und {{b}} Orten auf der Karte angezeigt.",
  "dealMap.routeRestored": "Deine Route von heute wurde wieder geladen.",
  "dealMap.routeKeptToday": "Diese Route bleibt heute für dich gespeichert. Die Unternehmen sind bis morgen für andere Routen gesperrt.",
  "dealMap.routeAllHeld": "Die passenden Unternehmen sind heute bereits in anderen Routen.",
  "dealMap.routeSaveFailed": "Die Route konnte nicht gespeichert werden. Bitte erneut versuchen.",
  "dealMap.routeListTitle": "Generierte Route",
  "dealMap.routeListTitleN": "Route {{n}}",
  "dealMap.routeListAria": "Liste der Routenstopps",
  "dealMap.routeOpenAgain": "In Apple Maps öffnen",
  "dealMap.routeOpenApple": "In Apple Maps öffnen",
  "dealMap.routeOpenGoogle": "In Google Maps öffnen",
  "dealMap.routeExportPdf": "Als PDF exportieren",
  "dealMap.routePdfOrder": "Reihenfolge",
  "dealMap.routePdfName": "Name",
  "dealMap.routePdfStatus": "Status",
  "dealMap.routePdfAddress": "Adresse",
  "dealMap.routePdfBlocked": "PDF-Export wurde blockiert. Bitte Pop-ups für diese Seite erlauben.",
  "dealMap.routePdfPrintHint": "Im Druckdialog „Als PDF speichern“ wählen.",
  "dealMap.routeHideLine": "Linie ausblenden",
  "dealMap.routeShowLine": "Linie einblenden",
  "dealMap.routeClear": "Route löschen",
  "dealMap.routeRemoveStop": "Stopp entfernen",
  "dealMap.routeStart": "Start",
  "dealMap.routeReturn": "Rückkehr / Ziel",
  "dealMap.routeCompaniesAtStop": "{{count}} Unternehmen an diesem Ort",
  "customerStatus.kupfer": "Kupfer",
  "customerStatus.bronze": "Bronze",
  "customerStatus.silber": "Silber",
  "customerStatus.gold": "Gold",
  "customerStatus.antwort-abwarten": "Antwort abwarten",
  "customerStatus.unknown": "Unbekannte Phase",
  "customerStatus.lost": "Verloren",

  "tabs.more": "Mehr",
  "tabs.menuOpen": "Weitere Bereiche öffnen",
  "tabs.menuClose": "Menü schließen",

  "manual.formLead":
    "Termin für einen Kunden anlegen. Gib die E-Mail-Adresse ein und wähle die gleiche Leistung wie auf /buchen. Der Kunde muss kein Konto haben.",
  "employeeManual.formLead":
    "Termin für einen Kunden anlegen. Gib die Kundendaten ein und wähle die passende Leistung. Der Termin erscheint danach in deinen manuellen Buchungen.",
  "manual.customerTitle": "Kundendaten",
  "manual.firstName": "Vorname",
  "manual.lastName": "Nachname",
  "manual.email": "E-Mail",
  "manual.phone": "Telefon",
  "manual.serviceTitle": "Leistung",
  "manual.service": "Leistung",
  "manual.servicePlaceholder": "Leistung auswählen …",
  "manual.duration": "Dauer",
  "manual.durationPlaceholder": "Dauer auswählen …",
  "manual.deliveryLabel": "Ort",
  "manual.deliveryPlaceholder": "Bitte wählen",
  "manual.deliveryStudio": "Im Studio",
  "manual.deliveryOnsite": "Vor Ort",
  "manual.deliveryEdeka": "Edeka, Ölmühlenweg 4",
  "manual.deliveryRequired": "Bitte einen Ort auswählen.",
  "manual.customTimeTitle": "Individuelle Uhrzeit",
  "manual.customTimeHour": "Stunde",
  "manual.customTimeMinute": "Minute",
  "manual.customTimeHint":
    "Optional: genaue Startzeit setzen (ab 08:00). Überschreibt die Slot-Auswahl.",
  "manual.customTimeInvalid": "Bitte eine gültige Uhrzeit zwischen 08:00 und 22:00 wählen.",
  "manual.conflictWarning":
    "Achtung: Diese Uhrzeit überschneidet sich mit einer bestehenden Buchung. Die manuelle Buchung ist trotzdem möglich.",
  "manual.applyTravelFee": "Anfahrtspauschale (39 €)",
  "manual.useCustomPrice": "Preis manuell setzen",
  "manual.customPrice": "Preis (€)",
  "manual.customPriceActive": "manuell",
  "manual.customPriceInvalid": "Bitte einen gültigen Preis angeben.",
  "manual.customPriceTooHigh": "Der Preis darf maximal 1.000 € betragen.",
  "manual.priceLabel": "Preis",
  "manual.free": "Kostenfrei",
  "manual.dateTitle": "Datum & Uhrzeit",
  "manual.arranged": "Termin wird telefonisch abgestimmt (nach Vereinbarung).",
  "manual.slotsLoading": "Verfügbare Zeiten werden geladen…",
  "manual.slotsEmpty":
    "An diesem Tag sind keine passenden Termine verfügbar. Bitte einen anderen Tag wählen.",
  "manual.slotsNeedDuration": "Bitte zuerst eine Dauer auswählen.",
  "manual.addressTitle": "Massageadresse (vor Ort)",
  "manual.companyName": "Name / Firma",
  "manual.address": "Massageadresse",
  "manual.addressNotes": "Hinweise zur Massageadresse",
  "manual.voucherTitle": "Gutschein",
  "manual.hasVoucher": "Kunde hat einen Gutschein (Anfahrt entfällt)",
  "manual.voucherTerms": "Gutschein wird zum Termin mitgebracht.",
  "manual.detailsTitle": "Zahlung & Notizen",
  "manual.payment": "Zahlungsart",
  "manual.paymentOnSite": "Vor Ort",
  "manual.paymentLater": "Nach Termin / Rechnung",
  "manual.paymentStripe": "Online-Zahlungslink (Stripe)",
  "manual.paymentStripeHint":
    "Ab 24 Stunden im Voraus wird der Termin 12 Stunden reserviert. Bei kurzfristigeren Terminen bleibt der Slot frei, bis die Zahlung eingeht.",
  "manual.notes": "Notiz / Anmerkung (INTERN)",
  "manual.notesPlaceholder": "Optionale Anmerkung zur Buchung… (INTERN)",
  "manual.notifyCustomer": "Kunde per E-Mail benachrichtigen",
  "manual.submit": "Manuelle Buchung anlegen",
  "employeeManual.submit": "Manuellen Termin anlegen",
  "manual.submitting": "Wird angelegt…",
  "manual.successKicker": "Buchung gespeichert",
  "manual.successTitle": "Manuelle Buchung angelegt",
  "manual.successLead":
    "Die Buchung für {{email}} wurde erfolgreich im Admin-Dashboard gespeichert.",
  "employeeManual.successLead":
    "Die Buchung für {{email}} wurde erfolgreich gespeichert und erscheint in deinen manuellen Terminen.",
  "manual.successService": "Leistung",
  "manual.successNotification": "Benachrichtigung",
  "manual.successNotificationYes": "Kunde wurde per E-Mail informiert.",
  "manual.successNotificationNo": "Keine Kunden-E-Mail versendet.",
  "manual.successPaymentLink": "Zahlungslink",
  "manual.successPaymentLinkCopy": "Link kopieren",
  "manual.successPaymentLinkCopied": "Link kopiert",
  "manual.successStatusReserved": "Reserviert, Zahlung ausstehend (Slot 12 Std. gehalten)",
  "manual.successStatusImmediate": "Sofortzahlung ausstehend (Slot nicht gehalten)",
  "manual.successClose": "Alles klar",
  "manual.listTitle": "Manuelle Buchungen",
  "manual.listLead":
    "Alle manuell angelegten Buchungen, sortiert nach Termin (frühester zuerst). Status, interne Notizen und Stornierung wie bei den übrigen Buchungen.",

  "revenue.formLead":
    "Umsatz erfassen, der nicht über eine Buchung im System läuft — z. B. Barzahlung vor Ort oder nachträgliche Korrektur.",
  "revenue.formTitle": "Umsatzeintrag",
  "revenue.amount": "Betrag (€)",
  "revenue.amountRequired": "Bitte einen gültigen Betrag größer als 0 € angeben.",
  "revenue.date": "Datum",
  "revenue.dateRequired": "Bitte ein Datum angeben.",
  "revenue.massageType": "Massageart",
  "revenue.massageTypePlaceholder": "Keine Angabe",
  "revenue.submit": "Umsatz speichern",
  "revenue.submitting": "Wird gespeichert…",
  "revenue.submitError": "Der Umsatzeintrag konnte nicht gespeichert werden.",
  "revenue.success": "Umsatzeintrag gespeichert.",
  "revenue.listTitle": "Gespeicherte Einträge",
  "revenue.listLead": "Manuelle Umsatzeinträge nach Datum sortiert (neueste zuerst).",
  "revenue.loadError": "Einträge konnten nicht geladen werden.",
  "revenue.colDate": "Datum",
  "revenue.colAmount": "Betrag",
  "revenue.colType": "Massageart",
  "revenue.colCreated": "Erfasst am",
  "revenue.colActions": "Aktionen",
  "revenue.delete": "Löschen",
  "revenue.deleteTitle": "Umsatzeintrag löschen",
  "revenue.deleteConfirm": "{{amount}} vom {{date}} wirklich löschen?",
  "revenue.deleteError": "Eintrag konnte nicht gelöscht werden.",

  "comparison.lead":
    "Umsatz für einen Tag oder einen Zeitraum auswerten. Buchungen zählen am Termintag; manuelle Buchungen und Umsatzeinträge sind in „Manuell“ ausgewiesen, Online-Aufladungen am Zahlungstag.",
  "comparison.from": "Von",
  "comparison.to": "Bis",
  "comparison.apply": "Auswerten",
  "comparison.loading": "Wird geladen…",
  "comparison.loadError": "Umsatzvergleich konnte nicht geladen werden.",
  "comparison.dateRequired": "Bitte mindestens ein Startdatum angeben.",
  "comparison.dateHint":
    "Ein einzelner Tag: gleiches Datum bei Von und Bis. Mehrere Tage: Enddatum wählen. Die Auswertung aktualisiert sich automatisch.",
  "comparison.periodRange": "{{from}} – {{to}}",
  "comparison.totalRevenue": "Umsatz gesamt",
  "comparison.bookingRevenue": "Online-Buchungen",
  "comparison.manualRevenue": "Manuell (Buchungen + Einträge)",
  "comparison.topUpRevenue": "Online-Aufladungen",
  "comparison.dayCount": "{{count}} Tag(e)",
  "comparison.bookingCount": "{{count}} Buchung(en)",
  "comparison.manualCount":
    "{{bookings}} manuelle Buchung(en) · {{entries}} Umsatzeintrag/einträge",
  "comparison.topUpCount": "{{count}} Aufladung(en)",
  "comparison.colDate": "Datum",
  "comparison.colBookings": "Online",
  "comparison.colManual": "Manuell",
  "comparison.colTopUps": "Aufladungen",
  "comparison.colTotal": "Gesamt",
  "comparison.totalRow": "Summe",

  "login.kicker": "Admin · Intern",
  "login.title": "Admin",
  "login.titleEm": "Login",
  "login.lead": "Melde dich mit deinem Admin-Konto an, um Buchungen und Kundendaten einzusehen.",
  "login.email": "E-Mail",
  "login.password": "Passwort",
  "login.submit": "Anmelden",
  "login.submitting": "Anmelden…",
  "login.forgotPassword": "Passwort vergessen?",
  "login.backToSite": "← Zur Website",
  "login.failed": "Login fehlgeschlagen.",
  "login.noAccess": "Dieses Konto hat keinen Zugriff auf das Admin-Dashboard.",

  "accessDenied.title": "Kein Zugriff",
  "accessDenied.lead":
    "Dieses Konto hat keinen Admin-Zugriff. Bitte melde dich mit einem Admin-Konto an oder wende dich an die Verwaltung.",

  "dashboard.kicker": "Intern · Dr. Hoffmann",
  "dashboard.title": "Admin",
  "dashboard.titleEm": "Dashboard",
  "dashboard.welcome": "Willkommen{{name}}. Hier siehst du Website-Aktivität, Termine und Kundendaten.",
  "dashboard.welcomeName": ", {{firstName}}",
  "dashboard.loadError": "Dashboard konnte nicht geladen werden.",
  "dashboard.notification.regionAria": "Neue Aktivität",
  "dashboard.notification.title": "Neue Aktivität",
  "dashboard.notification.clearAll": "Alle schließen",
  "dashboard.notification.dismiss": "Benachrichtigung schließen",
  "dashboard.notification.view": "Im Kalender ansehen",
  "dashboard.notification.newBooking":
    "Neue Buchung: {{service}} — {{name}}, {{when}} ({{status}})",
  "dashboard.notification.updatedBooking":
    "Buchung aktualisiert: {{service}} — {{name}}, {{when}} ({{status}})",

  "dateRange.label": "Zeitraum",
  "dateRange.all": "Gesamt",
  "dateRange.7d": "7 Tage",
  "dateRange.30d": "30 Tage",
  "dateRange.90d": "90 Tage",
  "dateRange.custom": "Zeitraum",
  "dateRange.from": "Von",
  "dateRange.to": "Bis",
  "dateRange.inPeriod": "im gewählten Zeitraum",
  "dateRange.fromDate": "ab {{date}}",
  "dateRange.toDate": "bis {{date}}",
  "dateRange.range": "{{from}} – {{to}}",

  "overview.loading": "Daten werden geladen…",
  "overview.noData": "Keine Daten verfügbar.",
  "overview.scopeNote.all":
    "Alle Buchungen.",
  "overview.scopeNote.drHoffmann":
    "Nur Buchungen über die Dr.-Hoffmann-Website (keine Tawan-Spa-Leistungen).",
  "overview.scopeNote.tawanSpa":
    "Nur Buchungen über die Tawan-Spa-Website (keine Dr.-Hoffmann-Leistungen).",

  "brandFilter.label": "Marke",
  "brandFilter.all": "Alle",
  "brandFilter.drHoffmann": "Dr. Hoffmann Massage",
  "brandFilter.tawanSpa": "Tawan Spa",
  "ortFilter.label": "Ort",
  "ortFilter.all": "Alle",
  "ortFilter.studio": "Im Studio",
  "ortFilter.edeka": "Edeka, Ölmühlenweg 4",
  "ortFilter.onsite": "Vor Ort",
  "overview.stats.totalCustomers": "Kunden gesamt",
  "overview.stats.newInPeriod": "{{count}} neu {{period}}",
  "overview.stats.qrCustomers": "QR Kunden",
  "overview.stats.tawanQrCustomers": "Tawan QR Kunden",
  "overview.stats.emailVerified": "{{count}} E-Mail bestätigt",
  "overview.stats.totalBookings": "Buchungen gesamt",
  "overview.stats.upcomingToday": "{{upcoming}} kommend · {{today}} heute",
  "overview.stats.bookingsInPeriod": "Buchungen im Zeitraum",
  "overview.stats.bookings": "Buchungen",
  "overview.stats.revenueInPeriod": "Umsatz im Zeitraum",
  "overview.stats.revenueTotal": "Umsatz gesamt",
  "overview.stats.revenueHint":
    "Am Termin-/Eintragsdatum, ohne Stornos; inkl. manuelle Buchungen und Umsatzeinträge",
  "overview.stats.manualRevenuePart":
    "davon {{amount}} manuell (Buchungen + Umsatzeinträge)",
  "overview.stats.manualRevenueBreakdown":
    "Manuelle Buchungen {{bookings}} · Umsatzeinträge {{entries}}",
  "overview.stats.registrationReminderSent": "Registrierungs-Erinnerungen",
  "overview.stats.registrationReminderClicks":
    "{{clicks}} eindeutige Klicks auf „Jetzt Termin sichern“ · {{rate}} Klickrate",
  "overview.customersBySource": "Kunden nach Quelle",
  "overview.bookingsBySource": "Buchungen nach Quelle",
  "overview.recentSignups": "Neue Registrierungen",
  "overview.recentSignupsPeriod": "Neue Registrierungen (Zeitraum)",
  "overview.viewAllSignups": "Alle Registrierungen anzeigen",
  "overview.recentBookings": "Letzte Buchungen",
  "overview.recentBookingsPeriod": "Letzte Buchungen (Zeitraum)",

  "source.website": "Webseite",
  "site.tawanSpa": "Tawan Spa",
  "site.drHoffmann": "Dr. Hoffmann Massage",
  "source.hoffmannQr": "Dr. Hoffmann QR",
  "source.tawanQr": "Tawan QR",
  "source.drHoffmann": "Dr. Hoffmann",

  "status.pendingEmailVerification": "Noch nicht verbindlich (E-Mail offen)",
  "status.pendingEmployee": "Wartet auf Bestätigung",
  "status.reservedAwaitingPayment": "Reserviert, Zahlung ausstehend",
  "status.awaitingImmediatePayment": "Sofortzahlung ausstehend",
  "status.pendingPayment": "Zahlung ausstehend",
  "status.confirmed": "Bestätigt",
  "status.cancelled": "Storniert",
  "status.expired": "Abgelaufen",
  "cancelledBy.customer": "durch Kunde (selbst)",
  "cancelledBy.admin": "durch Team (Dashboard)",
  "cancelledBy.staff": "durch Team (E-Mail-Link)",
  "cancelledBy.teamLegacy": "durch Team",
  "calendar.bookingDetail.cancelledBy": "Storniert durch",
  "calendar.bookingDetail.cancelledAt": "Storniert am",
  "status.completed": "Bezahlt",
  "status.noShow": "Nicht erschienen",

  "service.dr-hoffmann-consultation": "Lizenzpartner Erstbesuch",
  "service.dr-hoffmann-business-event": "WM-Aktion",
  "service.dr-hoffmann-studio": "Dr. Hoffmann Massage im Studio",
  "service.dr-hoffmann-mobile": "Dr. Hoffmann Massage Vor Ort",
  "service.dr-hoffmann-wakeup-studio": "Wake-Up im Studio",
  "service.dr-hoffmann-wakeup-onsite": "Wake-Up vor Ort",
  "service.dr-hoffmann-wakeup-onsite-voucher": "Wake-Up vor Ort",
  "service.dr-hoffmann-classic-studio": "Classic Massage im Studio",
  "service.dr-hoffmann-classic-onsite": "Classic Massage vor Ort",
  "service.dr-hoffmann-premium-studio": "Intense Massage im Studio",
  "service.dr-hoffmann-premium-onsite": "Intense Massage vor Ort",
  "service.dr-hoffmann-classic-plus-business-studio": "Classic+ im Studio",
  "service.dr-hoffmann-classic-plus-business-onsite": "Classic+ vor Ort",
  "service.dr-hoffmann-intense-plus-business-studio": "Intense+ im Studio",
  "service.dr-hoffmann-intense-plus-business": "Intense+ vor Ort",
  "service.dr-hoffmann-wakeup-plus-business": "Wake-Up+ für Unternehmen",
  "service.thai-massage": "Traditionelle Thai-Massage",
  "service.thai-oil-massage": "Thai Ölmassage",
  "service.hot-stone-massage": "Hot-Stone-Massage",
  "service.massagesessel": "Tawan Spa Massagesessel",

  "calendar.lead":
    "Termine als Tages-, Wochen- oder Monatsansicht. Wähle einen Tag, um die Buchungen zu sehen.",
  "calendar.viewAria": "Kalenderansicht",
  "calendar.view.day": "Tag",
  "calendar.view.week": "Woche",
  "calendar.view.month": "Monat",
  "calendar.weekRange": "{{from}} – {{to}}",
  "calendar.loadError": "Kalender konnte nicht geladen werden.",
  "calendar.legend": "Tag mit Termin(en) oder Umsatz",
  "calendar.awaitingPayment": "Noch nicht bezahlt",
  "calendar.awaitingPaymentShort": "Unbezahlt",
  "calendar.daysWithBookings": "{{count}} Tag(e) mit Einträgen in diesem Monat",
  "calendar.noDayEntries": "Keine Termine oder Umsatzeinträge an diesem Tag.",
  "calendar.noAppointments": "Keine Termine an diesem Tag.",
  "calendar.revenueEntry": "Umsatz",
  "calendar.revenueNoType": "Keine Massageart angegeben",
  "calendar.revenueDetail.kicker": "Manueller Umsatz",
  "calendar.revenueDetail.title": "Umsatzeintrag",
  "calendar.revenueDetail.date": "Datum",
  "calendar.revenueDetail.amount": "Betrag",
  "calendar.revenueDetail.massageType": "Massageart",
  "calendar.revenueDetail.created": "Erfasst am",
  "calendar.appointments": "{{count}} Termin(e)",
  "calendar.prevMonth": "← Zurück",
  "calendar.nextMonth": "Weiter →",
  "calendar.closedDay": "Samstag und Sonntag geschlossen",
  "calendar.bookingDetail.title": "Buchungsdetails",
  "calendar.bookingDetail.start": "Beginn",
  "calendar.bookingDetail.end": "Ende",
  "calendar.bookingDetail.duration": "Dauer",
  "calendar.bookingDetail.location": "Ort",
  "calendar.bookingDetail.brand": "Marke",
  "calendar.bookingDetail.studioSchedule": "Studio-Zeitplan",
  "calendar.bookingDetail.studioThursday": "Nur Donnerstag",
  "calendar.bookingDetail.studioWeekday": "Mo–Fr (Wochentag)",
  "calendar.bookingDetail.option": "Gebuchte Option",
  "calendar.bookingDetail.created": "Gebucht am",
  "calendar.bookingDetail.cancellationReason": "Storno-Grund",
  "calendar.bookingDetail.customerNotes": "Anmerkungen",
  "calendar.bookingDetail.serviceAddress": "Massageadresse",
  "calendar.bookingDetail.addressNotes": "Hinweise zur Massageadresse",
  "calendar.bookingDetail.none": "—",
  "calendar.bookingDetail.hint": "Hinweis",
  "calendar.bookingDetail.pendingEmailVerification":
    "Diese Buchung ist noch nicht verbindlich (z. B. Hotel-Tablet / Leonardo Nikolai). Der Kunde hat die E-Mail-Adresse noch nicht bestätigt — der Termin wird erst danach offiziell übermittelt und unser Team per E-Mail informiert.",

  "bookings.lead":
    "Alle Buchungen verwalten. Status und interne Notizen können angepasst werden. Stornierte Buchungen blendest du über die Checkbox ein. Kundendaten sind schreibgeschützt.",
  "bookings.statusFilter": "Status",
  "bookings.includePast": "Vergangene Termine anzeigen",
  "bookings.showCancelled": "Stornierte Buchungen anzeigen",
  "bookings.showExpired": "Abgelaufene Termine anzeigen",
  "bookings.loadError": "Buchungen konnten nicht geladen werden.",
  "bookings.saveError": "Speichern fehlgeschlagen.",
  "bookings.noShowTitle": "Als nicht erschienen markieren?",
  "bookings.noShowConfirm":
    "{{name}} · {{when}} — Der Kunde erhält eine E-Mail, dass er nicht zum Termin erschienen ist.",
  "bookings.noShowConfirmBtn": "Nicht erschienen bestätigen",
  "bookings.noShowBusy": "Wird gespeichert…",
  "bookings.notesError": "Notiz konnte nicht gespeichert werden.",
  "bookings.deleteError": "Buchung konnte nicht storniert werden.",
  "bookings.delete": "Stornieren",
  "bookings.deleteTitle": "Buchung stornieren",
  "bookings.deleteConfirm": "{{name}} · {{when}}",
  "bookings.deleteConfirmBtn": "Stornieren",
  "bookings.deleteBusy": "Wird storniert…",
  "bookings.deleteReasonLabel": "Grund für die Stornierung",
  "bookings.deleteReasonHint":
    "Der Grund wird dem Kunden in der Storno-E-Mail mitgeschickt — z. B. warum der Termin entfällt oder ein Alternativvorschlag.",
  "bookings.deleteReasonPlaceholder": "z. B. Termin entfällt — bitte neu buchen",
  "bookings.permanentDelete": "Endgültig löschen",
  "bookings.permanentDeleteTitle": "Buchung endgültig löschen",
  "bookings.permanentDeleteConfirm":
    "Diese Buchung wird unwiderruflich aus der Datenbank entfernt (nicht nur storniert). {{name}} · {{when}}",
  "bookings.permanentDeleteConfirmBtn": "Endgültig löschen",
  "bookings.permanentDeleteReasonLabel": "Grund (optional)",
  "bookings.permanentDeleteReasonHint":
    "Optional für interne Dokumentation.",
  "bookings.permanentDeleteReasonPlaceholder": "z. B. Testbuchung",
  "bookings.loading": "Buchungen werden geladen…",
  "bookings.empty": "Keine Buchungen gefunden.",
  "bookings.col.appointment": "Termin",
  "bookings.col.created": "Erstellt",
  "bookings.sort.appointmentAsc": "Nach Termindatum: frühester Termin zuerst",
  "bookings.sort.appointmentDesc": "Nach Termindatum: spätester Termin zuerst",
  "bookings.sort.createdAsc": "Nach Erstellung: älteste zuerst",
  "bookings.sort.createdDesc": "Nach Erstellung: neueste zuerst",
  "bookings.col.service": "Leistung",
  "bookings.col.customer": "Kunde",
  "bookings.col.price": "Preis",
  "bookings.col.payment": "Zahlung",
  "bookings.col.status": "Status",
  "bookings.col.customerNotes": "Anmerkungen",
  "bookings.col.notes": "Notiz (intern)",
  "bookings.col.actions": "Aktionen",
  "bookings.notesPlaceholder": "Interne Notiz…",
  "bookings.badge.freeTawan": "Gratis Tawan",
  "bookings.badge.manual": "Manuell",
  "bookings.pagination": "Seite {{page}} von {{pages}} ({{total}} gesamt)",

  "customers.lead":
    "Kundendaten, Status, Guthaben und interne Notizen verwalten. Auf dem Handy öffnen sich die Details als Dialog.",
  "customers.searchPlaceholder": "Name, E-Mail oder Telefon suchen…",
  "customers.sortLabel": "Sortierung",
  "customers.sortNewest": "Neueste zuerst",
  "customers.sortOldest": "Älteste zuerst",
  "customers.sortMostBookings": "Meiste Buchungen",
  "customers.pageJumpLabel": "Seite",
  "customers.pageJumpSubmit": "Öffnen",
  "customers.loadError": "Kunden konnten nicht geladen werden.",
  "customers.detailError": "Kundendetails konnten nicht geladen werden.",
  "customers.statusUpdateError": "Kundenstatus konnte nicht aktualisiert werden.",
  "customers.loading": "Kunden werden geladen…",
  "customers.empty": "Keine Kunden gefunden.",
  "customers.bookingCount": "{{count}} Buchung(en)",
  "customers.registrationHistoryTitle": "Registrierungsverlauf",
  "customers.registrationHistoryLead":
    "Alle Konten nach Registrierungsdatum, damit sichtbar bleibt, wer sich wann registriert hat.",
  "customers.registrationHistoryCount": "{{from}}-{{to}} von {{total}}",
  "customers.registeredAt": "Registriert: {{date}}",
  "customers.openDetails": "Kundendetails öffnen",
  "customers.selectHint": "Kunde auswählen, um Details zu sehen.",
  "customers.detailLoading": "Details werden geladen…",
  "customers.field.email": "E-Mail",
  "customers.field.phone": "Telefon",
  "customers.field.firstName": "Vorname",
  "customers.field.lastName": "Nachname",
  "customers.field.registered": "Registriert",
  "customers.field.source": "Quelle",
  "customers.field.status": "Status",
  "customers.field.registrationSite": "Webseite",
  "customers.field.freeChair": "Gratis-Sessel (Tawan)",
  "customers.freeChair.used": "Bereits genutzt",
  "customers.freeChair.available": "Noch verfügbar",
  "customers.field.emailVerified": "E-Mail bestätigt",
  "customers.field.referralLink": "Empfehlungslink",
  "customers.field.referralUses": "Link genutzt",
  "customers.field.referralBalance": "Kontoguthaben",
  "customers.detailsEditTitle": "Kundendaten bearbeiten",
  "customers.detailsSaved": "Kundendaten gespeichert.",
  "customers.detailsError": "Kundendaten konnten nicht gespeichert werden.",
  "customers.notesTitle": "Interne Kundennotiz",
  "customers.notesLabel": "Notiz",
  "customers.notesPlaceholder": "Notiz zum Kunden…",
  "customers.notesAdd": "Notiz hinzufügen",
  "customers.notesSaved": "Notiz gespeichert.",
  "customers.notesError": "Notiz konnte nicht gespeichert werden.",
  "customers.notesDeleted": "Notiz gelöscht.",
  "customers.notesDeleteError": "Notiz konnte nicht gelöscht werden.",
  "customers.notesEmpty": "Noch keine internen Notizen.",
  "customers.notesCreatedAt": "Erstellt: {{date}}",
  "customers.notesUpdatedAt": "Bearbeitet: {{date}}",
  "customers.notesEdit": "Bearbeiten",
  "customers.notesDelete": "Löschen",
  "customers.notesDeleting": "Löscht…",
  "customers.referralCreditTitle": "Kontoguthaben anpassen",
  "customers.referralCreditLead":
    "Manuell Kontoguthaben gutschreiben oder entfernen. Der Betrag kann nur für Massagen auf der Website eingelöst werden.",
  "customers.referralCreditAction": "Guthaben-Aktion",
  "customers.referralCreditModeAdd": "Hinzufügen",
  "customers.referralCreditModeRemove": "Entfernen",
  "customers.referralCreditAmount": "Betrag",
  "customers.referralCreditSubmit": "Guthaben hinzufügen",
  "customers.referralCreditSubmitting": "Wird hinzugefügt…",
  "customers.referralCreditError": "Guthaben konnte nicht hinzugefügt werden.",
  "customers.referralDebitSubmit": "Guthaben entfernen",
  "customers.referralDebitError": "Guthaben konnte nicht entfernt werden.",
  "customers.bookingHistoryNote":
    "Die Buchungshistorie zeigt die bisherigen Termine dieses Kunden.",
  "customers.bookingHistory": "Buchungshistorie",
  "customers.noBookings": "Keine Buchungen.",
  "customers.permanentDelete": "Kunde endgültig löschen",
  "customers.permanentDeleteTitle": "Kunde endgültig löschen",
  "customers.permanentDeleteConfirm":
    "Kunde und alle zugehörigen Buchungen werden unwiderruflich gelöscht. {{name}} · {{when}}",
  "customers.permanentDeleteConfirmBtn": "Endgültig löschen",
  "customers.permanentDeleteReasonLabel": "Bestätigung (optional)",
  "customers.permanentDeleteReasonHint":
    "Diese Aktion kann nicht rückgängig gemacht werden.",
  "customers.permanentDeleteReasonPlaceholder": "z. B. Doppelkonto",
  "customers.deleteError": "Kunde konnte nicht gelöscht werden.",
  "customers.exportCsv": "CSV exportieren",
  "customers.exporting": "Export wird erstellt…",
  "customers.exportError": "CSV-Export fehlgeschlagen.",
  "topups.lead":
    "Dokumentation aller Kontoguthaben-Aufladungen und manuellen Guthabenänderungen.",
  "topups.statsAria": "Aufladungs-Summen",
  "topups.stats.paid": "Bezahlt via Stripe",
  "topups.stats.added": "Gutgeschrieben",
  "topups.stats.bonus": "Bonusguthaben",
  "topups.stats.removed": "Entfernt",
  "topups.searchPlaceholder": "Name, E-Mail, Telefon oder Stripe-ID suchen…",
  "topups.source.all": "Alle Quellen",
  "topups.source.stripe": "Stripe",
  "topups.source.manual": "Manuell",
  "topups.source.bookingCancellation": "Storno-Gutschrift",
  "topups.loadError": "Aufladungen konnten nicht geladen werden.",
  "topups.loading": "Aufladungen werden geladen…",
  "topups.empty": "Keine Aufladungen gefunden.",
  "topups.kind.stripe": "Stripe-Aufladung",
  "topups.kind.bookingCancellation": "Automatische Storno-Gutschrift",
  "topups.kind.adminAdd": "Manuell hinzugefügt",
  "topups.kind.adminRemove": "Manuell entfernt",
  "topups.field.when": "Wann",
  "topups.field.paid": "Gezahlt",
  "topups.field.credit": "Gutschrift",
  "topups.field.bonus": "Bonus",
  "topups.field.currentBalance": "Aktuelles Guthaben",
  "topups.field.actor": "Ausgelöst durch",
};

export default de;
